module.exports = __webpack_public_path__ + "media/bootstrap-icons/chevron-double-left-21b8affd.svg";